function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Pico Search v0.5.1 · The MIT License · Copyright © 2023 Shivam Mishra.
function p(e, t) {
  if (e.length < t.length) {
    var n = e;
    e = t, t = n;
  }

  var i = e.length,
      o = t.length;
  if (!o) return 0;
  var s = Math.max(1, i / 2) - 1,
      a = Array(o).fill(!1),
      m = Array(i).fill(""),
      r = 0;

  for (var _n = 0; _n < i; _n++) {
    var u = e[_n];

    for (var h = 0; h < o; h++) {
      var d = t[h];

      if (h <= _n + s && h + s >= 1 && u === d && !a[h]) {
        a[h] = !0, m[r++] = u;
        break;
      }
    }
  }

  if (!r) return 0;
  var c = 0;

  for (var _n2 = 0, _u = 0; _u < o; _u++) {
    a[_u] && (t[_u] !== m[_n2] && c++, _n2++);
  }

  var l = r,
      g = (l / i + l / o + (l - c / 2) / l) / 3,
      f = 0;
  o = Math.min(4, o);

  for (var _n3 = 0; _n3 < o; _n3++) {
    e[_n3] === t[_n3] && f++;
  }

  return g + f * .1 * (1 - g);
}

function y(e, t) {
  if (t && e.length !== t.length) throw new Error("The number of values must be equal to the number of weights");
  var i = e.reduce(function (s, a, m) {
    var r = t ? t[m] : 1;
    return s + a * r;
  }, 0),
      o = t ? t.reduce(function (s, a) {
    return s + a;
  }, 0) : e.length;
  return i / o;
}

function S(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Math.max(t, Math.min(i, e));
}

function T(e) {
  return e.split(/\s+/).filter(function (t, i, o) {
    return t && o.indexOf(t) === i;
  });
}

var b = {
  CONTAINS_MATCH: 1.2,
  FIRST_SIMILARITY: 1.1,
  STARTS_WITH: 1.05
};

function O(e, t, i, o) {
  var s = [],
      a = o && o.threshold || .8,
      m = t.trim().toLowerCase();
  return t ? (e.forEach(function (r) {
    var c = [],
        l = [];

    var _iterator = _createForOfIteratorHelper(i),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var f = _step.value;
        var n = typeof f == "string" ? f : f.name;

        if (typeof f != "string" ? l.push(f.weight) : l.push(1), Object.prototype.hasOwnProperty.call(r, n) && typeof r[n] == "string") {
          var u = r[n].trim().toLowerCase(),
              h = A(u, m);
          c.push(h);
        } else c.push(0);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var g = y(c, l);
    g >= a && s.push({
      object: r,
      similarity: g
    });
  }), s.sort(function (r, c) {
    return c.similarity - r.similarity;
  }), s.map(function (r) {
    return r.object;
  })) : e;
}

function A(e, t) {
  var i = T(e),
      s = T(t).map(function (a) {
    var m = i.map(function (l) {
      return W(l, a);
    }),
        r = Math.max.apply(Math, _toConsumableArray(m)),
        c = m[0];
    return r === c ? r * b.FIRST_SIMILARITY : S(r);
  });
  return y(s);
}

function W(e, t) {
  var i = p(e, t);
  return e.includes(t) ? i * b.CONTAINS_MATCH : i;
}

export { O as picoSearch };